import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import FishListTabs from "@/components/menu-management/fish-chips/fish-chips-list/fish-list-tabs";
import DraftListTabs from "@/components/menu-management/fish-chips/fish-chips-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import {
  fetchAllFishChips,
  clearFishChipsMessages,
} from "@/redux/slice/menu-manage-slice/fish-chips";
import hasPermission from "@/hooks/hasPermission";

function FishAndChips() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.fishChips);
  useEffect(() => {
    dispatch(fetchAllFishChips(user?.restaurant_id));
    dispatch(clearFishChipsMessages());
  }, [user?.restaurant_id]);


  if (getLoading) return <TableSkeleton links={backofficeLinks} />;
  return (
    <Layout2
         pageName={{ title: "Fish and Chips List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Fish and Chips", path: "/backoffice/menu/fish-chips" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
   <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
         
          {hasPermission("back_office.menu_management.create_fish_chips") && (
            <Link to={"/backoffice/menu/fish-chips/create"}>
              <Button>
                <Plus /> Create Fish & Chips
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-fish-and-chips" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Fish and Chips
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <FishListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default FishAndChips;
